import type { RootState } from "../../app/store";

export const selectPageState = (state: RootState) => state.calculator;

export const getSelectedContractLengthInMonths = (state: RootState) => {
  if (state.calculator.form.contractPeriodInMonths && state.calculator.financingStructure && state.calculator.financingStructure.availableContractLengths) {
    return state.calculator.financingStructure.availableContractLengths.find((x) => x.monthsFrom === state.calculator.form.contractPeriodInMonths);
  }
};
